import { useUserProfile } from 'contexts/AuthContext'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useState } from 'react'

export const useUserProfileStatus = () => {
  const { userProfile, getUserProfile } = useUserProfile()

  const [rdStatus, setRDStatus] = useState()
  const [ptStatus, setPtStatus] = useState()
  const [insuranceProviderId, setInsuranceProviderId] = useState()
  const [insuranceProvided, setInsuranceProvided] = useState(false)

  useEffect(() => {
    if (userProfile) {
      setRDStatus(userProfile.skuStatus?.rd)
      setPtStatus(userProfile.skuStatus?.pt)
      setInsuranceProviderId(userProfile.insuranceProviderId)
      setInsuranceProvided(userProfile.insuranceProvided)
    }
  }, [userProfile])

  const isStateChanged = useMemo(() => {
    return userProfile?.isStateChanged || false
  }, [userProfile])

  const shouldSkipFlow = useMemo(() => {
    const insuranceProviderIdSkipped =
      insuranceProviderId && insuranceProviderId !== 5
    return insuranceProvided && insuranceProviderIdSkipped && !isStateChanged
  }, [insuranceProvided, insuranceProviderId, isStateChanged])

  const shouldSkipWLCScheduledTime = useMemo(() => {
    return rdStatus === 2 && !isStateChanged
  }, [rdStatus, isStateChanged])

  const shouldSkipMSKScheduledTime = useMemo(() => {
    return ptStatus === 2 && !isStateChanged
  }, [ptStatus, isStateChanged])

  const getUserProfileStatus = useCallback(
    async ({ forceFetch = false } = {}) => {
      let _userProfile = userProfile
      if (_.isEmpty(_userProfile) || forceFetch) {
        _userProfile = await getUserProfile()
      }
      const rdStatus = _userProfile.skuStatus?.rd
      const ptStatus = _userProfile.skuStatus?.pt
      const insuranceProviderId = _userProfile.insuranceProviderId
      const insuranceProvided = _userProfile.insuranceProvided
      return {
        shouldSkipFlow:
          insuranceProvided &&
          insuranceProviderId &&
          insuranceProviderId !== 5 &&
          !isStateChanged,
        shouldSkipWLCScheduledTime: rdStatus === 2 && !isStateChanged,
        shouldSkipMSKScheduledTime: ptStatus === 2 && !isStateChanged,
        ..._userProfile,
      }
    },
    [getUserProfile, userProfile, isStateChanged]
  )

  return {
    shouldSkipFlow,
    getUserProfileStatus,
    userProfile,
    shouldSkipWLCScheduledTime,
    shouldSkipMSKScheduledTime,
  }
}
